<div class="register-container">
  <div class="logo-container">
    <img class="logo-safecloud-1" src="../../assets/img/safecloud-1.png" alt="logo">
  </div>
  <div class="message">
    <h5>PENDIENTE DE VALIDAR</h5>
    <span>El correo electrónico {{ email }} está pendiente de validación por parte de los administradores. Cuando esté aprobado el acceso recibirá un correo electrónico.</span>
    <a href="">Portal Safecloud</a>
  </div>
</div>
